import React from 'react';

const BlogIntro = ({
  color = '#48B0FF',
  size = 12,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
  >
    <defs>
      <clipPath id="clip0_284_4556">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
    <g clipPath="url(#clip0_284_4556)">
      <path d="M4.5 14.4572L13.06 5.89717L16.1029 8.94006L7.54289 17.5001H4.5V14.4572ZM21.5 23.5001H2.5V20.5001H21.5V23.5001ZM17.88 7.16295L14.8371 4.12006L16.3136 2.64361C16.5083 2.44887 16.8217 2.44887 17.0164 2.64361L19.3564 4.98361C19.5512 5.17835 19.5512 5.49177 19.3564 5.68651L17.88 7.16295Z" fill={color} />
    </g>
  </svg>
);

export default BlogIntro;
